const ItemEditableStatusEnum = require('@/lib/Orders/ItemEditableStatus');

/**
 * A CartItemGroup is a subset of items in a Cart that share something in common.
 * (Currently only used to group items for the same session)
 * Items in a group are visually grouped together when displaying the cart.
 *
 * This should contain no logic. It is purely for presentation / grouping items.
 *
 * @constructor
 *
 * @param {string} key
 * @param {string} type
 */
const CartItemGroup = function (
    key,
    type
) {
    /**
     * A unique key for this group.
     * If it's a group for the same session it should be something like session-{sessionID}
     *
     * @type {string}
     */
    this.key = key;

    /**
     * The type of group. Possible values currently are 'default' or 'session'.
     *
     * @type {string}
     */
    this.type = type;

    /**
     * @type {CartLine[]}
     */
    this.items = [];

    /**
     * @type {SessionEvent}
     */
    this.event = null;

    /**
     * @type {Session}
     */
    this.session = null;

    /**
     * An optional group booking reference for this group.
     *
     * @type {string|null}
     */
    this.groupBookingReference = null;
};

CartItemGroup.prototype = {
    /**
     * @param {CartLine} item
     */
    addItem(item) {
        this.items.push(item);
    },

    /**
     * @param {?SessionEvent} event
     */
    setEvent(event) {
        this.event = event || null;
    },

    /**
     * @param {?Session} session
     */
    setSession(session) {
        this.session = session || null;
    },

    /**
     * @return {string}
     */
    getName() {
        if (this.session && this.session.name) {
            return this.session.name;
        }
        if (this.event && this.event.name) {
            return this.event.name;
        }

        return '';
    },

    /**
     * @returns {boolean}
     */
    containsUneditableLines() {
        return this.items.some((line) => line.editableStatus !== ItemEditableStatusEnum.IS_EDITABLE);
    },
};

module.exports = CartItemGroup;
